import { Box, SimpleGrid, Text } from '@mantine/core';
import { InfoField } from '../../../../../ui/infoField/InfoField';
import useGetDistributorCompany from '../hooks/useGetDistributorCompany';
import { useSearchParams } from 'react-router-dom';

export default function ClientInfo() {
  const [searchParams] = useSearchParams();
  const mac = searchParams.get('mac') || '';
  const { data } = useGetDistributorCompany({ mac });
  const companyInfo = data?.company;
  return (
    <div>
      <Text fw={600} mb="xs">
        납품처 정보
      </Text>
      <Box
        style={{
          borderTop: '1px solid var(--mantine-color-gray-3)',
          borderLeft: '1px solid var(--mantine-color-gray-3)',
        }}
      >
        <SimpleGrid cols={4} spacing={0} verticalSpacing={0}>
          <InfoField label="거래처명">{companyInfo?.name}</InfoField>
          <InfoField label="사업자 번호">{companyInfo?.businessNum}</InfoField>
          <InfoField label="대표자명">{companyInfo?.repName}</InfoField>
          <InfoField label="거래처 전화번호">{companyInfo?.tel}</InfoField>
          <InfoField label="거래처 이메일">{companyInfo?.email}</InfoField>
          <InfoField label="메모">{companyInfo?.memo}</InfoField>
        </SimpleGrid>
      </Box>
    </div>
  );
}
